import { Component, type ReactNode, type ErrorInfo, type CSSProperties } from "react";
import "../styles/tokens.css";
import "../styles/v3.css";
import { AuthGuard } from "../../lib/components/AuthGuard";
import { AppShell } from "../components/shell/AppShell";

class V3ErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {
    // Could log to an error reporting service
  }

  render() {
    if (this.state.hasError) {
      const card: CSSProperties = {
        maxWidth: 400,
        margin: "80px auto",
        padding: 24,
        background: "var(--color-background-primary)",
        border: "var(--kuvio-border-default)",
        borderRadius: "var(--border-radius-lg)",
        fontFamily: "var(--font-sans)",
        textAlign: "center",
      };
      return (
        <div data-v3 style={{ height: "100vh", background: "var(--color-background-tertiary)" }}>
          <div style={card}>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 8 }}>Something went wrong</div>
            <div style={{ fontSize: 13, color: "var(--color-text-secondary)", marginBottom: 16 }}>
              An error occurred while rendering this page.
            </div>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this.setState({ hasError: false });
              }}
              style={{ fontSize: 13, color: "var(--color-text-info)" }}
            >
              Reload
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export function V3Layout() {
  return (
    <V3ErrorBoundary>
      <AuthGuard>
        <AppShell />
      </AuthGuard>
    </V3ErrorBoundary>
  );
}
